export const ForwardArrowIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.99984 0.664062L5.05984 1.60406L8.77984 5.33073H0.666504V6.66406H8.77984L5.05984 10.3907L5.99984 11.3307L11.3332 5.9974L5.99984 0.664062Z" />
  </svg>
);
